import { create } from 'zustand'

export interface Branding {
  appName: string
  organizationName: string
  supportEmail: string
  logoUrl: string
}

interface BrandingState extends Branding {
  loaded: boolean
  loadBranding: () => Promise<void>
  setBranding: (partial: Partial<Branding>) => void
}

const FALLBACK: Branding = {
  appName: 'Admin',
  organizationName: '',
  supportEmail: '',
  logoUrl: '',
}

export const useBrandingStore = create<BrandingState>((set) => ({
  ...FALLBACK,
  loaded: false,

  loadBranding: async () => {
    try {
      const res = await fetch('/api/settings/branding', { credentials: 'include' })
      if (!res.ok) {
        set({ loaded: true })
        return
      }
      const data = await res.json()
      set({
        appName: data.app_name || FALLBACK.appName,
        organizationName: data.organization_name || FALLBACK.organizationName,
        supportEmail: data.support_email || FALLBACK.supportEmail,
        logoUrl: data.logo_url || FALLBACK.logoUrl,
        loaded: true,
      })
    } catch (err) {
      console.error('[brandingStore] Failed to load branding:', err)
      set({ loaded: true })
    }
  },

  setBranding: (partial) => set((state) => ({ ...state, ...partial })),
}))
